import React from "react";

function CustomerDetailsModal({ customer, onClose }) {
  if (!customer) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white w-full max-w-3xl p-6 rounded-lg shadow-lg">
        {/* Modal Header */}
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-xl font-semibold">Customer Details</h2>
          <button
            className="text-gray-600 hover:text-gray-900"
            onClick={onClose}
          >
            &times;
          </button>
        </div>

        {/* Customer Details */}
        <div className="grid grid-cols-2 gap-6">
          <div>
            <strong className="block text-sm font-medium text-gray-700">First Name:</strong>
            <p>{customer.first_name}</p>
          </div>
          <div>
            <strong className="block text-sm font-medium text-gray-700">Last Name:</strong>
            <p>{customer.last_name}</p>
          </div>
          <div>
            <strong className="block text-sm font-medium text-gray-700">Email:</strong>
            <p>{customer.email}</p>
          </div>
          <div>
            <strong className="block text-sm font-medium text-gray-700">Phone:</strong>
            <p>{customer.phone}</p>
          </div>
          <div>
            <strong className="block text-sm font-medium text-gray-700">Address:</strong>
            <p>{customer.address}</p>
          </div>
          <div>
            <strong className="block text-sm font-medium text-gray-700">Organization:</strong>
            <p>{customer.organization}</p>
          </div>
          <div>
            <strong className="block text-sm font-medium text-gray-700">Type:</strong>
            <p>{customer.type}</p>
          </div>
          <div>
            <strong className="block text-sm font-medium text-gray-700">Status:</strong>
            <p>{customer.status}</p>
          </div>
        </div>

        {/* Modal Footer */}
        <div className="flex justify-end mt-6">
          <button
            className="bg-gray-600 text-white px-4 py-2 rounded-md hover:bg-gray-700"
            onClick={onClose}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}

export default CustomerDetailsModal;